function _toLoopbackFilterOperation({ source, filter, value, type }) {

    if (type === 'model') source = source + '.id';
    if (['boolean', 'bool'].includes(type)) value = ([true, "true", "positive"].includes(value));

    const query = q => ({ [source]: q });
    const operation = (op, _value = value) => query({ [op]: _value });
    const resc = (_value = value) => _value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")

    switch (filter) {
        case 'EQUALS':
        case 'EQUAL':
            return operation('eq');
        case 'NOT EQUAL':
        case 'NOT EQUALS':
            return operation('ne');
        case 'SUPERIOR':
            return operation('gt');
        case 'SUPERIOR OR EQUAL':
        case 'SUPERIOR OR EQUALS':
            return operation('gte');
        case 'INFERIOR':
            return operation('lt');
        case 'INFERIOR OR EQUAL':
        case 'INFERIOR OR EQUALS':
            return operation('lte');
        case 'IN':
            return operation('inq');
        case 'NOT IN':
            return operation('nin');
        case 'EMPTY':
            return { $or: [operation('exists', false), operation('in', [null, ""])] };
        case 'NOT EMPTY':
            return { ...operation('exists', true), ...operation('nin', [null, ""]) };
        case 'EXIST':
        case 'EXISTS':
            return operation('exists', true);
        case 'NOT EXIST':
        case 'NOT EXISTS':
            return operation('exists', false);
        case 'CONTAIN':
        case 'CONTAINS':
            if (type === 'array')
                return operation('elemMatch');
            else
                return query({ regexp: new RegExp(resc()) + 'i' });
        case 'NOT CONTAIN':
        case 'NOT CONTAINS':
            if (type === 'array')
                return query({ not: { elemMatch: value } });
            else
                return query({ not: { regexp: new RegExp(resc()) + 'i' } });
    }
}

function toLoopbackFilter(arr) {
    const where = { and: [] };

    for (let jaj of arr) {
        where.and.push(_toLoopbackFilterOperation(jaj));
    }

    return where;
}

module.exports = toLoopbackFilter;